import { UserEssentialsFragment } from '@/fragments/__gen'

type User = UserEssentialsFragment
type Module = UserEssentialsFragment["organisation"]["suite"]["moduleSetItems"][number]["module"]

// A module manager has a user module for at least one module
const isModuleManager = (user: User) => (
	user.organisation.suite.moduleSetItems.some(msi => msi.module.hasUserModule)
)

// Top level managers can manage the teams of every module, everyone else needs
// an active user module for that specific module.
export const canManageTeams = (user: User, module: Module) => (
	user.topLevelManager || module.hasUserModule
)

export const canManageAnyModuleTeams = (user: User) => (
	user.topLevelManager || isModuleManager(user)
)

// Module managers can invite users and give them access to the modules they
// manage, but they can't change or remove existing users.
export const canManageUsers = (user: User) => (
	user.topLevelManager || isModuleManager(user)
)

export const canEditUserDetails = (user: User) => user.topLevelManager
